<template>
	<div id="sign-in">
		<div class="logo-box">
			<img class="logo" src="@/assets/fixed-invitation/logo.png" alt="">
		</div>
		<div class="title-box">
			<p class="title">{{ $t('sign.register_id') }}</p>
		</div>

		<div v-if="tagShow" class="switch-box">
			<span :class="isPhone ? 'active' : ''" @click="switchType(true)">{{ $t('sign.mobile_regist') }}</span>
			<span :class="!isPhone ? 'active' : ''" @click="switchType(false)">{{ $t('sign.email_regist') }}</span>
		</div>
		<div class="form-box">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">

				<el-form-item prop="phone">
					<div class="input-box phone">
						<div class="line"></div>
						<i :class="isPhone ? 'el-icon-mobile-phone' : 'el-icon-message'" class="left" />
						<code-select v-if="isPhone" :area-list="areaList" class="left" @code-change="codeChange" />
						<el-input v-model="ruleForm.phone" ref="phone" type="text" size="medium"
							class="value-input username-input left" :class="isPhone ? '' : 'mail-input'"
							:placeholder="isPhone ? $t('sign.input_phone') : $t('sign.input_email')" autocomplete="on"
							clearable />
					</div>
				</el-form-item>

				<el-form-item prop="password">
					<div class="input-box password">
						<el-input v-model="ruleForm.password" name="password" :type="eyeOpen ? 'text' : 'password'"
							class="value-input password-input" size="medium" :placeholder="$t('sign.set_password')"
							prefix-icon="el-icon-lock" autocomplete="on" clearable />
						<span class="eye" @click="eyeOpen = !eyeOpen">
							<img v-if="!eyeOpen" src="@/assets/fixed-invitation/eye.png" alt="">
							<img v-else src="@/assets/fixed-invitation/eye-o.png" alt="">
						</span>
					</div>
					<span class="pass-tip">({{ $t('sign.password_rule') }})</span>
				</el-form-item>

				<el-form-item prop="inviteCode">
					<div class="input-box invite-code">
						<div class="code">{{ $t('sign.invite_code') }}：{{ruleForm.inviteCode}}</div>
					</div>
				</el-form-item>
			</el-form>
		</div>
		<div class="protocal-box">
			<el-checkbox class="check-input" v-model="checked" @change="checkChange"></el-checkbox>
			<span class="protocal">
				{{ $t('sign.agree') }}<a :class="$i18n.locale"
					:href="`https://misc.jgzpro.com/protocol/?language=${language}`" target="_blank"
					rel="noopener noreferrer">{{ $t('sign.user_agr') }}{{ $t('sign.and') }}</a><a :class="$i18n.locale"
					:href="`https://misc.jgzpro.com/policy/?language=${language}`" target="_blank"
					rel="noopener noreferrer">{{ $t('sign.privacy_agr') }}</a>
			</span>
			<!-- https://sanrenxing.pro/protocol/ -->
		</div>
		<div class="sign-in-btn" :class="active ? 'active' : ''" @click="goInputCode">{{ $t('sign.regist') }}</div>
		<div><span class="login-btn" @click="goDown">{{ $t('sign.already_regist') }}</span></div>
		<!-- <div class="down-logo">
            <img src="@/assets/fixed-invitation/login-logo.png" alt="">
            <div class="sign-in-btn down" @click="goDown">去下载</div>
        </div> -->
		<div class="alert" v-show="alertShow">
			<span>{{message}}</span>
		</div>
	</div>
</template>

<script>
	import CodeSelect from '@/components/CodeSelect/new.vue'
	import {
		isNum,
		validPassword,
		validEmail
	} from '@/utils/validate'
	const Base64 = require('js-base64').Base64
	export default {
		name: 'SignIn',
		components: {
			CodeSelect
		},
		data() {
			const self = this
			const validatePhone = (rule, value, callback) => {
				// debugger
				if (self.isPhone && !isNum(value)) {
					callback(new Error(self.$t('sign.phone_warn')))
				} else if (!self.isPhone && !validEmail(value)) {
					callback(new Error(self.$t('sign.email_warn')))
				} else {
					let params = {}
					if (self.isPhone) {
						let mobile = parseInt(value + '')
						params.mobile = (self.area + '') + mobile
					} else {
						params.email = value
					}

					self.$MyAxios.get(`/api/accounts/${self.isPhone ? 'mobile' : 'email'}/isAvailable`, {
							params: params
						},
						response => {
							if (response.code === 1) {
								if (response.data) {
									callback()
								} else {
									callback(new Error('该用户已存在'))
								}
							}
						}, error => {

						})
				}
			}
			const validatePass = (rule, value, callback) => {
				if (!validPassword(value)) {
					self.active = false
					callback(new Error(self.$t('sign.password_warn')))
				} else {
					if (self.checked) {
						self.active = true
					} else {
						self.active = false
					}
					callback()
				}
			}
			const checkCode = (rule, value, callback) => {
				callback()
			}
			return {
				isPhone: true,
				areaList: [],
				area: '852',
				drawer: false,
				eyeOpen: false,
				alertShow: false,
				message: '',
				ruleForm: {
					phone: '',
					password: '',
					inviteCode: '',
				},
				rules: {
					phone: [{
						required: true,
						validator: validatePhone,
						trigger: 'blur'
					}],
					password: [{
						required: true,
						validator: validatePass,
						trigger: 'change'
					}],
					code: [{
						required: true,
						validator: checkCode,
						trigger: 'change'
					}]
				},
				inviteCode: 'AFDIXE',
				checked: false,
				active: false,
				language: '',
				tagShow: true,
			}
		},
		mounted() {
			if (this.$i18n.locale === 'zh') {
				this.language = 'CHINESE'
			} else if (this.$i18n.locale === 'zh-h') {
				this.language = 'CHINESETRAD'
			} else {
				this.language = 'ENGLISH'
			}

			let data = this.$route.query.d
			if (data) {
				this.infoCode = Base64.decode(data).split('_')[1];
			}
			this.ruleForm.inviteCode = this.$route.query.inviteCode ? this.$route.query.inviteCode : this.infoCode
			this.getAreaList()
			// alert(this.ruleForm.inviteCode)
			// this.$nextTick(() => {
			//     let data = this.$route.query.d
			//     if(data) {
			//         this.infoCode = Base64.decode(data).split('_')[1];
			//     }
			//     this.ruleForm.inviteCode = this.$route.query.inviteCode ? this.$route.query.inviteCode : this.infoCode
			// })
			// window.onpageshow = () => {
			//     // alert(this.ruleForm.inviteCode)
			//     setTimeout(() => {
			//         let data = this.$route.query.d
			//         if(data) {
			//             this.infoCode = Base64.decode(data).split('_')[1];
			//         }
			//         this.ruleForm.inviteCode = this.$route.query.inviteCode ? this.$route.query.inviteCode : this.infoCode
			//     }, 2000);
			// }

			//ok渠道  和非小号渠道 隐藏手机注册
			let code = this.ruleForm.inviteCode;
			// console.log(111,code)
			if (code == 'V4DQAM' || code == 'VFISAR') {
				this.isPhone = false;
				this.tagShow = false;
			}


		},
		methods: {
			getAreaList() {
				this.$MyAxios.get(`/api/accounts/locations`, {},
					response => {
						if (response.code === 1) {
							this.showLoading = false;
							let data = response.data
							this.areaList = data
						}
					}, error => {
						this.showLoading = false;
					})
			},
			handleClose(done) {
				done()
			},
			codeChange(code) {
				this.area = code
			},
			switchType(flag) {
				// 
				this.isPhone = flag
				this.ruleForm.phone = '';
				this.$refs['ruleForm'].resetFields()
				this.ruleForm.inviteCode = this.$route.query.inviteCode ? this.$route.query.inviteCode : this.infoCode
			},
			goInputCode() {
				if (this.area == 86 && this.isPhone) {
					this.alertShow = true
					this.message = this.$t('sign.no_cn')
					setTimeout(() => {
						this.alertShow = false
					}, 2000);
					return
				}
				this.$refs.ruleForm.validate(valid => {
					if (valid) {
						if (this.checked) {
							if (this.$route.meta.from === 'fxh') {
								this.$router.push({
									name: 'SignInCodeFxh',
									params: {
										form: this.ruleForm,
										area: this.area,
										tag: this.isPhone
									}
								})
							}
							this.$router.push({
								name: 'SignInCode',
								params: {
									form: this.ruleForm,
									area: this.area,
									tag: this.isPhone
								}
							})
						} else {
							this.alertShow = true
							this.message = '请先阅读并同意协议'
							setTimeout(() => {
								this.alertShow = false
							}, 2000);
						}
					}
				})
			},
			checkChange() {
				if (this.checked) {
					this.$refs.ruleForm.validate(valid => {
						if (valid) {
							this.active = true
						}
					})
				} else {
					this.active = false
				}
			},
			goDown() {
				if (this.$route.meta.from === 'fxh') {
					window.open(window.location.protocol + "//" + window.location.host + '/down-fromfxh')
				}
				window.open(window.location.protocol + "//" + window.location.host)
			}
		}
	}
</script>

<style lang='less'>
	#sign-in {
		height: 100vh;
		width: 100%;
		background: #ffffff;
		padding: 88px 60px 0 60px;

		.logo-box {
			margin-bottom: 6px;

			.logo {
				width: 136px;
				height: 136px;
			}
		}

		.title-box {
			margin: 0 auto;
			margin-bottom: 30px;
			line-height: 93px;

			p {
				margin: 0 auto;
				line-height: 48px;
				font-size: 32px;
				color: #33333a;
				font-weight: 500;

				&.title {
					font-size: 50px;
					line-height: 70px;
					margin-bottom: 10px;
					font-weight: bold;
				}

				&.blue {
					line-height: 46px;
					font-size: 32px;
					color: #33333A;
				}
			}
		}

		.switch-box {
			height: 80px;
			width: 456px;
			border-radius: 40px;
			background: #F2F3F5;
			padding: 8px;
			margin: 0 auto;
			margin-bottom: 30px;

			span {
				display: inline-block;
				height: 64px;
				width: 220px;
				border-radius: 32px;
				line-height: 64px;
				color: #9598A6;

				&.active {
					background: #ffffff;
					color: #FFA41F;
				}
			}
		}

		.form-box {
			margin-bottom: 90px;

			.el-form-item {
				margin-bottom: 50px;
				text-align: left;

				.el-form-item__error {
					font-size: 28px;
				}
			}

			.input-box {
				height: 100px;
				margin-bottom: 0px;
				border-bottom: 1px solid #EBECF0;

				.el-icon-mobile-phone,
				.el-icon-message {
					height: 100px;
					line-height: 100px;
					width: 40px;
					text-align: center;
					color: #33333a;
					margin-right: 10px;
					padding-left: 15px;
					font-size: 36px;
					vertical-align: middle;
					font-weight: bold;
				}

				&.phone {
					position: relative;

					.line {
						width: 2px;
						height: 32px;
						position: absolute;
						left: 180px;
						top: 34px;
						background: #EBECF0;
					}
				}

				&.password {
					position: relative;

					.el-input__suffix {
						right: 70px;
					}

					.el-input__icon {
						color: #33333a;
						font-weight: bold;

						&.el-input__clear {
							color: #CCCED9;
						}
					}

					.eye {
						display: inline-block;
						position: absolute;
						height: 34px;
						width: 34px;
						top: 33px;
						right: 4px;

						img {
							height: 34px;
							width: 34px;
						}
					}
				}
			}

			.pass-tip {
				font-size: 24px;
				line-height: 34px;
				color: #CCCED9;
				padding-left: 80px;
			}

			.el-input {
				height: 100px;
				font-size: 40px;

				.el-input__inner {
					height: 100px;
					padding: 0 60px;
					border: none;
					font-size: 34px;

					&::-webkit-input-placeholder {
						font-size: 32px;
					}
				}

				.el-input__prefix {
					width: 40px;

					.el-input__icon:before {
						line-height: 100px;
						width: 40px;
					}
				}

				.el-input__suffix {
					width: 40px;

					.el-input__icon:before {
						line-height: 100px;
						width: 40px;
						font-size: 40px;
					}
				}

				&.is-disabled .el-input__inner {
					color: #9598A6;
					background-color: #F8F9FB;
				}
			}

			.code-select .area-list-box.show .el-input .el-input__inner {
				padding: 0 10px;
				font-size: 34px;
			}

			.username-input {
				width: 445px;
				margin-top: -1px;

				&.mail-input {
					width: 575px // right: ;
				}

				.el-input__inner {
					padding: 0 10px;
				}
			}

			.password-input {
				margin-top: -1px;
			}

			.invite-code {
				text-align: center;
				background: #F8F9FB;
				border-bottom: 0px;
				width: 500px;
				height: 56px;
				margin: 0 auto;
				line-height: 56px;

				.code {
					display: inline-block;
					color: #9598A6;
					font-size: 30px;
					margin-left: 20px;
					vertical-align: middle;
				}
			}
		}

		.protocal-box {
			text-align: left;
			margin-bottom: 30px;
		}

		.check-input {
			width: 32px;
			height: 32px;
			margin-right: 5px;
			vertical-align: middle;

			.el-checkbox__inner {
				width: 32px;
				height: 32px;

				&:after {
					height: 16px;
					width: 10px;
					left: 6px;
				}
			}
		}

		.protocal {
			font-size: 24px;
			line-height: 32px;
			color: #818499;
			vertical-align: middle;

			a {
				font-size: 24px;
				color: #FFA41F;

				&.en {
					font-style: italic;
				}
			}
		}

		.sign-in-btn {
			width: 630px;
			height: 88px;
			border-radius: 8px;
			color: #FFFFFF;
			background: #F2F3F5;
			text-align: center;
			font-size: 34px;
			line-height: 88px;
			margin-bottom: 30px;

			&.active {
				background: #FFA41F;
			}
		}

		.login-btn {
			color: #FFA41F;
			font-size: 34px;
			text-decoration: underline;
		}

		.down-logo {
			height: 120px;
			width: 100vw;
			position: fixed;
			bottom: 0;
			left: 0;
			text-align: left;
			padding: 10px 30px;
			border-top: 1px solid #EBECF0;

			img {
				width: 300px;
				height: 100px;
				vertical-align: middle;
				margin-right: 180px;
			}

			.down {
				width: 200px;
				display: inline-block;
				vertical-align: middle;
				margin: 0;
			}
		}

		.alert {
			position: fixed;
			z-index: 3;
			top: 40%;
			left: 50%;
			height: 60px;
			width: auto;
			padding: 0 30px;
			transform: translateX(-50%);
			border-radius: 8px;
			background: rgba(0, 0, 0, .9);
			color: #ffffff;
			line-height: 60px;
		}
	}
</style>